import styled from 'styled-components';
import svg from './IconThumb.background.svg';
import tealsvg from './IconThumbTeal.background.svg';

export const IconThumb = styled.img.attrs({ src: String(svg) })`
  height: 60px;
  width: 60px;
`;

export const IconThumbTeal = styled.img.attrs({ src: String(tealsvg) })`
  height: 60px;
  width: 60px;
`;
